// extracted by mini-css-extract-plugin
export default {"container":"Intro_container__FDJC8"};